import { USER_ROUTES } from "@/modules/users/constants";

export default [
  {
    path: USER_ROUTES.LIST.path,
    name: USER_ROUTES.LIST.name,
    meta: {
      title: USER_ROUTES.LIST.title,
      authRequired: true,
    },
    component: () => import("@/modules/users/views/items.vue"),
  },
  {
    path: USER_ROUTES.EDIT.path,
    name: USER_ROUTES.EDIT.name,
    meta: {
      title: USER_ROUTES.EDIT.title,
      authRequired: true,
    },
    component: () => import("@/modules/users/views/edit.vue"),
  },
  {
    path: USER_ROUTES.CREATE.path,
    name: USER_ROUTES.CREATE.name,
    meta: {
      title: USER_ROUTES.CREATE.title,
      authRequired: true,
    },
    component: () => import("@/modules/users/views/edit.vue"),
  },
];
